import { gql } from 'apollo-angular';

export const RowFragment = gql`
  fragment Row on RowOutput {
    id
    coordinate
    legend
  }
`;
